import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { withStyles } from "@material-ui/styles";

// SERVICES

const styles = theme => ({
  cardHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  }
});

export const CardHeader = withStyles(styles)(props => {
  const { label, children } = props;

  return (
    <div
      className={classnames('card-header')}
      // style={{
      //   minHeight: window.innerWidth > 1500 ? 100 : 200
      // }}
    >
      <div className={classnames("card-header-text")}>{label}</div>
      {children}
    </div>
  );
});

CardHeader.propTypes = {
  label: PropTypes.string.isRequired
};

CardHeader.defaultProps = {};
